/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled    from 'styled-components';
import { Media } from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledTableListItemText = styled.div`
  display: block;
  ${Media.Tablet`
    flex: 1;
  `} 
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledTableListItemText/index.js